import { Button, Flex } from '@bridebook/aura';
import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { removeMarketFromPath, useDispatch } from '@bridebook/web/app-shared/lib/utils';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { memo } from 'react';

const NWSDiscountCardLocked = () => {
  const { t } = useTranslation('articles');
  const dispatch = useDispatch();
  const router = useRouter();
  const market = useMarket();

  const articlePath = removeMarketFromPath(router.asPath.split('?')[0], market.prefix).replace(
    /^\//,
    '',
  );
  const next = encodeURIComponent(articlePath);

  const signupHref = `${UrlHelper.signup}?skipOnboarding=true&next=${next}`;
  const loginHref = `${UrlHelper.login}&next=${next}`;

  const trackSignupClick = (cta: string) => () => {
    dispatch(
      clickedOnLoggedOutPage({
        clickedLocation: 'nwsDiscountCard',
        clickedSection: 'ctaBanner',
        cta,
      }),
    );
  };

  return (
    <>
      <span className="w-fit rounded-full bg-indigo-crush-10 px-2.5 py-1.5 typo-2xs font-bold tracking-[0.1em] text-indigo-crush uppercase">
        {t('nwsDiscountCard.exclusive.badge')}
      </span>
      <h2 className="!my-0 !text-2xl leading-tight !font-extrabold text-pretty">
        {t('nwsDiscountCard.exclusive.title')}
      </h2>
      <p className="!mb-0 typo-sm text-pretty text-space-75">
        {t('nwsDiscountCard.exclusive.description')}
      </p>
      <Flex className="flex-col gap-2.5">
        <Button asChild className="w-full !text-white">
          <Link href={signupHref} onClick={trackSignupClick(t('nwsDiscountCard.signupButton'))}>
            {t('nwsDiscountCard.signupButton')}
          </Link>
        </Button>
        <Flex className="items-center justify-center gap-1.5 typo-sm text-space-75">
          {t('nwsDiscountCard.alreadyHaveAccount')}
          <Link
            href={loginHref}
            onClick={trackSignupClick(t('nwsDiscountCard.login'))}
            className="!font-bold !text-indigo-crush">
            {t('nwsDiscountCard.login')}
          </Link>
        </Flex>
      </Flex>
    </>
  );
};

export default memo(NWSDiscountCardLocked);
